<template>
  <div class="row">
    <div class="col-12">
      <div class="wrapper">
        <div class="wrapper-inner">
          <h2 class="title">
            Бонусная шкала для вебмастеров
          </h2>
          <p class="description">
            Процент бонусного вознаграждения зависит от товарооборота вебмастера за календарный месяц и суммируется с
            комиссией.
          </p>
          <div class="list">
            <div
              v-for="(item, index) in items"
              :key="index"
              class="list-item"
            >
              <div class="background" />
              <div class="list-wrapper">
                <div class="percent">
                  {{ item.percent }}
                </div>
                <div class="item-description">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BonusScale',
  data() {
    return {
      items: [
        {
          percent: '10%',
          description: '200 - 500 тыс руб',
        },
        {
          percent: '15%',
          description: '500 тыс - 1 млн руб',
        },
        {
          percent: '20%',
          description: '1 млн - 5 млн руб',
        },
        {
          percent: '25%',
          description: '5 млн - 7 млн руб',
        },
        {
          percent: '30%',
          description: 'от 7 млн руб',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  border-radius: 4px;
  padding: 24px;
  margin-bottom: 48px;
  background: #DFCDC0 url('../../assets/images/bonus-scale-bg.svg') no-repeat right bottom;
  @media (max-width: 1200px) {
    background-size: 35%;
  }
  @media (max-width: 576px) {
    border-radius: 0px;
    margin: 16px -16px 0 -16px;
    background-size: 100%;
  }
}
.wrapper-inner {
  padding: 40px;
  border-radius: 4px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%2321282B' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  @media (max-width: 576px) {
    padding: 25px;
    padding-bottom: 182px;
  }
}
.title {
  margin-bottom: 16px;
}
.description {
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.15px;
  margin-bottom: 48px;
  color: #21282B;
  max-width: 675px;
}
.list {
  display: flex;
  flex-wrap: wrap;
  @media (min-width: 768px) {
    justify-content: space-evenly;
  }
}
.list-item {
  position: relative;
  margin-right: 80px;
  margin-bottom: 57px;
  @media (max-width: 576px) {
    margin-right: 0;
  }
}
.background {
  position: absolute;
  width: 70px;
  height: 70px;
  background-color: #FDC300;
  border-radius: 100%;
  z-index: 1;
  top: -7px;
  left: 9px;
}
.percent {
  z-index: 2;
  position: relative;
  color: #21282B;
  font-size: 64px;
  line-height: 56px;
  font-weight: bold;
  margin-bottom: 8px;
  @media (max-width: 576px) {
    margin-right: 16px;
  }
}
.item-description {
  z-index: 2;
  position: relative;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.15px;
}
.list-wrapper {
  display: block;
  @media (max-width: 576px) {
    display: flex;
    align-items: center;
  }
}
</style>
